import { Injectable } from '@angular/core';
import { HttpService, Identity, ServiceResponse } from '@sdbn/appclient';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Route, RoutingPosition, TransportRouting, TransportRoutingIdentity } from '../routing-position.model';

@Injectable({
  providedIn: 'root'
})
export class TransportRoutingService {

  constructor(private http: HttpService) { }

  getTransportRouting(identity: TransportRoutingIdentity): Observable<TransportRouting> {
    return this.http.postWithContext<TransportRouting>(`${environment.changeTransportRoutingEndpoint}/routing`, identity);
  }

  save(transportRouting: TransportRouting): Observable<ServiceResponse> {
    return this.http.postWithContext<ServiceResponse>(`${environment.changeTransportRoutingEndpoint}/save`, transportRouting);
  }

  getPositionsforTransportProfile(identity: Identity): Observable<RoutingPosition[]> {
    return this.http.postWithContext(`${environment.transportRegistrationEndpoint}/profile-positions`, identity);
  }

  reloadRoute(identity: Identity): Observable<Route> {
    return this.http.postWithContext(`${environment.changeTransportRoutingEndpoint}/reload-route`, identity);
  }
}
